const tintColorLight = '#2f95dc';
const tintColorDark = '#fff';

export default {
  light: {
    text: '#000',
    background: '#fff',
    tint: tintColorLight,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorLight,
  },
  dark: {
    text: '#fff',
    background: '#000',
    tint: tintColorDark,
    tabIconDefault: '#ccc',
    tabIconSelected: tintColorDark,
  },
  azul: '#252B63',
  gold: '#FBB44F',
  chandproBlue: '#2358b6',
  chandproGreen: '#24727b',
  roxo: '#5c0b78ff',
  laranja_forte: '#fdc324ff',
  laranja_claro: '#fddc80ff',
  cinza_forte: '#707070ff',
  cinza_claro: '#b8b8b8ff',
  cinza: '#585858ff'
};
